import React from "react";
import Masonry from "react-masonry-css";
import { Link } from "react-router-dom";
import CtaStyle2 from "../Cta/CtaStyle2";
import Spacing from "../Spacing";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";

export default function Portfolio({ data }) {
  const { t } = useTranslation();
  const breakpoints = {
    default: 2,
    991: 1,
  };

  return (
    <Masonry
      breakpointCols={breakpoints}
      className="my-masonry-grid"
      columnClassName="my-masonry-grid_column"
    >
      {data.map((item, index) => (
        <div key={index} className="masonry-item">
          <div className="cs_portfolio cs_style_1">
            <div className="cs_portfolio_thumb cs_radius_15">
              <img src={item.imgUrl} alt={t('common.altPortfolio')} />
            </div>
            <div className="cs_portfolio_info">
              <p className="fs-1 cs_extra_bold cs_portfolio_title cs_fs_38 cs_color_orange_800">{item.title}</p>
              <p className="cs_portfolio_description">{item.description}</p>
            </div>
          </div>
          <a
            href="https://calendly.com/nicolas-rs/new-meeting"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="text-center">
              <Spacing lg="80" md="50" />
              <span className="cs_btn cs_style_1">
                {t('common.seeMore')}
                <span>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                  <i>
                    <Icon icon="fa6-solid:arrow-right" />
                  </i>
                </span>
              </span>
            </div>
          </a>
        </div>
      ))}
    </Masonry>
  );
}
